/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
 */

import mergeProps from "@/router/utils/mergeProps";

let ClientPortalInviteMain = () => import(/* webpackChunkName: "DashboardModule" */ '@/core/recoveryCoachingApp/client/Invite/ClientPortalInviteMain.vue')
let TeamMemberInviteMain = () => import(/* webpackChunkName: "DashboardModule" */ '@/core/recoveryCoachingApp/client/Invite/TeamMemberInviteMain.vue')
let CoachingPackageCheckoutMain = () => import(/* webpackChunkName: "DashboardModule" */ '@/core/recoveryCoachingApp/coach/CoachingPackages/Invite/CoachingPackageCheckoutMain')
let GroupPackageCheckoutMain = () => import(/* webpackChunkName: "DashboardModule" */ '@/core/recoveryCoachingApp/coach/CoachingPackages/Invite/GroupPackageCheckoutMain')


export default [



	{
		path: '/package/join/:coachId/:packageId/',
		name: 'CoachingPackageJoin',
		component: CoachingPackageCheckoutMain,
		props: mergeProps,
		meta:{
			isWhitelisted: true
		}
	},
	{
		path: '/app/group/join/:coachId/:packageId/',
		name: 'CoachingPackageGroupJoin',
		component: GroupPackageCheckoutMain,
		props: mergeProps,
		meta:{
			isWhitelisted: true
		}
	},

	{
		path: '/portal/invite/:coachId/:clientId',
		name: 'ClientInvite',
		component: ClientPortalInviteMain,
		props: mergeProps,
		meta:{
			isWhitelisted: true
		}
	},

	{
		path: '/team/invite/:ownerId/:inviteeId',
		name: 'TeamMemberInvite',
		component: TeamMemberInviteMain,
		props: mergeProps,
		meta:{
			isWhitelisted: true
		}
	},



]


